import { action } from 'easy-peasy';
import { IActionSetClientOptionsFilter } from '../types';

const setClientOptionsFilter: IActionSetClientOptionsFilter = action((state, payload) => {
  state.clientOptionsByTeam.filters = { ...state.clientOptionsByTeam.filters, ...payload };
});

export default setClientOptionsFilter;
